import { FETCH_NPS } from '../actions/types'
import { NPSActionProps, NPSStateProps } from '../types'

export const nps = (
  state: NPSStateProps = { data: null, loading: false },
  { type, data, loading }: NPSActionProps,
): NPSStateProps => {
  switch (type) {
    case FETCH_NPS:
      return { data, loading }

    default:
      return state
  }
}
